function e(e){return e===void 0?!0:typeof e==`string`||Array.isArray(e)?e.length===0:Object.keys(e).length===0}export{e as isEmpty};
//# sourceMappingURL=isEmpty-eMi1zfBb.js.map